import PropTypes from 'prop-types';
import React from 'react';

import Files from './Files';

const FilesContainer = ({ chapterId, course, ...props }) => {
  const filteredFiles = course.files.filter((f) => f.chapterId === chapterId);
  return <Files files={filteredFiles} {...props} />;
};

FilesContainer.propTypes = {
  chapterId: PropTypes.string,
  course: PropTypes.object.isRequired,
};

FilesContainer.defaultProps = {
  chapterId: undefined,
};

export default FilesContainer;
